import React from 'react'

export default () => (
  <div style={{ color: 'white' }}>
    We track activity in the app anonymously to understand how users interact and how to improve
    that. We do not collect any personally identifiable information.
  </div>
)
